import React from "react"
import { isRouteErrorResponse, useRouteError } from "react-router-dom"
import ErrorBoundary from "./ErrorBoundary"

const RouterErrorFallback: React.FC = () => {
  const routeError = useRouteError()

  const error: Error = React.useMemo(() => {
    if (routeError instanceof Error) {
      return routeError
    }
    if (isRouteErrorResponse(routeError)) {
      return new Error(`${routeError.status} ${routeError.statusText}: ${routeError.data}`)
    }
    return new Error(String(routeError))
  }, [routeError])

  return (
    <ErrorBoundary>
      <Thrower error={error} />
    </ErrorBoundary>
  )
}

const Thrower: React.FC<{ error: Error }> = ({ error }) => {
  throw error
}

export default RouterErrorFallback